import React from "react";
import { faBriefcase } from "@fortawesome/free-solid-svg-icons";

import Card from "../common/card";

import "./styles/works.css";

const Works = () => {
	return (
		<div className="works">
			<Card
				icon={faBriefcase}
				title="Work"
				body={
					<div className="works-body">
						<div className="work">
							<img
								src="https://media.licdn.com/dms/image/C4D0BAQGVLh28SyAv-g/company-logo_200_200/0/1631315215307?e=2147483647&v=beta&t=_afhmCf9MABYzhQJS7C4FkvllA1VSmIxeD51pR2eyR0"
								alt="facebook"
								className="work-image"
							/>
							<div className="work-title">Telkom Indonesia</div>
							<div className="work-subtitle">
								Fullstack Engineer - Internship
							</div>
							<div className="work-duration">Feb 2023 - Jun 2023</div>
						</div>

						<div className="work">
							<img
								src="https://media.licdn.com/dms/image/C560BAQHufXZ6qpC7Vg/company-logo_200_200/0/1630666848575?e=2147483647&v=beta&t=ZOy5cfLXA-qZGEHGHnA1tzrUeBd96URo1OWUBbHAc0E"
								alt="twitter"
								className="work-image"
							/>
							<div className="work-title">Politeknik Manufaktur Negeri Bangka Belitung</div>
							<div className="work-subtitle">
								Fullstack Engineer – Final Project
							</div>
							<div className="work-duration">Sep 2022 - Jan 2023</div>
						</div>

						<div className="work">
							<img
								src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTyWfykSef01pSpABH_p4WQ9wIWiau1K6zqKA&s"
								alt="twitter"
								className="work-image"
							/>
							<div className="work-title">Orbit Future Academy</div>
							<div className="work-subtitle">
								Foundation of AI – Apprenticeship
							</div>
							<div className="work-duration">Feb 2022 - Jun 2022</div>
						</div>
					</div>
				}
			/>
		</div>
	);
};

export default Works;
